import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const UpsertCodCommissionRange = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpsertCodCommissionRange,
        method: RequestType.POST,
        data,
    });

const DeleteCodCommissionRanges = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DeleteCodCommissionRanges,
        method: RequestType.POST,
        data,
    });

const InsertBulkCodCommissionRangesExcel = (formData: FormData) =>
    request({
        url: ApiURL.Command.InsertBulkCodCommissionRangesExcel,
        method: RequestType.POST,
        data: formData,
        requestType: 'FromForm',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        },
    });

const MPPaymentOnDeliveryCommissionCommand = {
    UpsertCodCommissionRange,
    DeleteCodCommissionRanges,
    InsertBulkCodCommissionRangesExcel,
};

export default MPPaymentOnDeliveryCommissionCommand;
